import React, {forwardRef, useEffect, useLayoutEffect, useState} from "react";
import {
    getCtrlOrAlt,
    getImagePathWithTheme,
    isInDraw,
    isInPageLibrary,
    isInPageTag,
    isInProjectList
} from "../../utils";
import {HEADER_HEIGHT, KEY_SELECT_RIGHT_SLIDER_MENU} from "../../Const";
import global from "@/global";
import {atom, useAtom} from "jotai";
import {atomSelectSliderRightMenu} from "@/views/Home/HomeIndex";
import {Tooltip, message} from "antd";
import {t} from "i18next";
import {APP_WEB_WWW} from "@/electron_interactive";
import {atomSliderWidth} from "@/App";



const DrawIndexSliderHeader = forwardRef((props:{onAction:any}, ref)=>{
    const [selectSliderRightMenu,setSelectSliderRightMenu] = useAtom(atomSelectSliderRightMenu);
    const [rightSliderWidth,setRightSliderWidth] = useAtom(atomSliderWidth);


    useLayoutEffect(()=>{
        return ()=>{

        }
    },[])

    return (
        <div className={'flex-row-vertical-center drag'} style={{
            height: `${HEADER_HEIGHT}px`,
            padding: '0 12px 0 16px',
            borderBottom: '1px solid var(--line-color)',
            marginLeft: '0px',
            zIndex: '9',
            flexShrink: '0'
        }}>
            <div className={'flex-row-vertical-center'} style={{width: '100%'}}>
                {
                    // rightSliderWidth > 0 &&
                    // <img className='img-32 hovered-gray-radius'
                    //      style={{marginLeft: '0px', marginRight: '6px'}}
                    //      src={getImagePathWithTheme('home_slider_library')} onClick={() => {
                    //     props.onAction('collapse')
                    // }}/>
                }

                <Tooltip arrow={false} title={<div className={'default-font-size'}>{t("Library")}<span
                    className={'tooltip-shortcut-key'}>{getCtrlOrAlt("Ctrl + 1")}</span></div>}>
                    <img
                        style={{marginLeft:'-4px'}}
                        className={(selectSliderRightMenu == 'library' ? 'select-gray-radius-background' : '') + ' img-32 hovered-gray-radius cursor-pointer'}
                        src={getImagePathWithTheme('slider_right_library.svg')} onClick={() => {
                        setSelectSliderRightMenu('library');
                        localStorage.setItem(KEY_SELECT_RIGHT_SLIDER_MENU, 'library');
                        props.onAction('library');
                    }}/>
                </Tooltip>

                <Tooltip arrow={false} title={<div className={'default-font-size'}>{t("Journal")}<span
                    className={'tooltip-shortcut-key'}>{getCtrlOrAlt("Ctrl + 2")}</span></div>}>
                    <img
                        className={(selectSliderRightMenu == 'journal' ? 'select-gray-radius-background' : '') + ' img-32 ml-6 hovered-gray-radius cursor-pointer'}
                        src={getImagePathWithTheme('slider_right_journal.svg')} onClick={() => {
                        setSelectSliderRightMenu('journal')
                        localStorage.setItem(KEY_SELECT_RIGHT_SLIDER_MENU, 'journal');
                        props.onAction('refresh');
                    }}/>
                </Tooltip>

                <Tooltip arrow={false} title={<div className={'default-font-size'}>{t("Highlights")}<span
                    className={'tooltip-shortcut-key'}>{getCtrlOrAlt("Ctrl + 3")}</span></div>}>
                    <img
                        className={(selectSliderRightMenu == 'highlight' ? 'select-gray-radius-background' : '') + ' img-32 ml-6 hovered-gray-radius cursor-pointer'}
                        src={getImagePathWithTheme('slider_right_highlight.svg')} onClick={() => {
                        setSelectSliderRightMenu('highlight')
                        localStorage.setItem(KEY_SELECT_RIGHT_SLIDER_MENU, 'highlight');
                        props.onAction('refresh');
                    }}/>
                </Tooltip>


                <Tooltip arrow={false} title={<div className={'default-font-size'}>{t("Info")}<span
                    className={'tooltip-shortcut-key'}>{getCtrlOrAlt("Ctrl + 4")}</span></div>}>
                    <img
                        className={(selectSliderRightMenu == 'info' ? 'select-gray-radius-background' : '') + ' img-32 ml-6 hovered-gray-radius cursor-pointer'}
                        src={getImagePathWithTheme('slider_right_info.svg')} onClick={() => {
                        if (isInPageLibrary() || isInPageTag() || isInProjectList()){
                            message.error(t("NoInformation1"));
                            return;
                        }

                        setSelectSliderRightMenu('info')
                        localStorage.setItem(KEY_SELECT_RIGHT_SLIDER_MENU, 'info');
                        props.onAction('info');
                    }}/>
                </Tooltip>

                <Tooltip arrow={false} title={<div className={'default-font-size'}>{t("Projects")}<span
                    className={'tooltip-shortcut-key'}>{getCtrlOrAlt("Ctrl + 5")}</span></div>}>
                    <img
                        className={(selectSliderRightMenu == 'project' ? 'select-gray-radius-background' : '') + ' img-32 ml-6 hovered-gray-radius cursor-pointer'}
                        src={getImagePathWithTheme('slider_project.svg')} onClick={() => {
                        setSelectSliderRightMenu('project')
                        localStorage.setItem(KEY_SELECT_RIGHT_SLIDER_MENU, 'project');
                        props.onAction('project');
                    }}/>
                </Tooltip>

                <Tooltip arrow={false} title={<div className={'default-font-size'}>{t("Web viewer")}<span
                    className={'tooltip-shortcut-key'}>{getCtrlOrAlt("Ctrl + 6")}</span></div>}>
                    <img
                        className={(selectSliderRightMenu == 'webview' ? 'select-gray-radius-background' : '') + ' img-32 ml-6 hovered-gray-radius cursor-pointer'}
                        src={getImagePathWithTheme('slider_webview.svg')} onClick={() => {
                        setSelectSliderRightMenu('webview')
                        localStorage.setItem(KEY_SELECT_RIGHT_SLIDER_MENU, 'webview');
                        props.onAction('webview');
                    }}/>
                </Tooltip>

                {/*<img className={'img-32 ml-6 hovered-gray-radius'} src={getImagePathWithTheme('slider_right_web')}/>*/}

                <div style={{flexGrow: '1'}}></div>
                {
                    // rightSliderWidth == 0 &&
                    <Tooltip arrow={false} title={<div className={'default-font-size'}>{t("Side panel")}<span
                        className={'tooltip-shortcut-key'}>{getCtrlOrAlt("Ctrl + 1")}</span></div>}>
                        <img className={'img-32 ml-6 hovered-gray-radius cursor-pointer'}
                             style={{marginTop:'1px'}}
                             src={getImagePathWithTheme('home_slider_library.svg')} onClick={() => {
                            props.onAction('collapse')
                        }}/>
                    </Tooltip>
                }

            </div>
        </div>
    )
})

export default DrawIndexSliderHeader;